



































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import WipTicket from "@/domainObjects/wip/WipTicket";
import TicketService from "@/services/TicketService";
import SubmitTicketButtonGroupMobile from "@/view/shared-components/mobile-only/SubmitTicketButtonGroupMobile.vue";
import SubmitTicketButtonGroupDesktop from "@/view/shared-components/desktop-only/SubmitTicketButtonGroupDesktop.vue";
import alertMixin from "@/mixins/alert-mixin";
import WipSAPForm from "@/view/wip/components/WipSAPForm.vue";
import WipProductInformation from "@/view/wip/components/WipProductForm.vue";
import WipCauseForm from "@/view/wip/components/WipCauseForm.vue";
import HoldQiDetailsForm from "@/view/hold/components/HoldQiDetailsForm.vue";
import WipQiDetailsForm from "@/view/wip/components/WipQiDetailsForm.vue";
import WipFileAttachments from "@/view/wip/components/WipFileAttachments.vue";
import screenSizeMixin from "@/mixins/screen-size-mixin";
import {mapGetters} from "vuex";
import LoadingActions from "@/store/actions/loading";
import Discrepancy from "@/domainObjects/wip/Discrepancy";

@Component({
    components: {
        WipFileAttachments,
        WipQiDetailsForm,
        HoldQiDetailsForm,
        WipCauseForm,
        WipProductInformation,
        WipSAPForm,
        SubmitTicketButtonGroupDesktop,
        SubmitTicketButtonGroupMobile,
    },
    mixins:[alertMixin, screenSizeMixin],
    computed: {
        ...mapGetters(['getGroups']),
    }
})

export default class EditWipTicketPage extends Vue {

    private ticketId:number = 0;
    private originalWipTicketStringified: string = "";
    private wipTicket:WipTicket = new WipTicket();
    private ticketChanged: boolean = false;
    private headerMessage: string = "";
    $_alertMixin_swalConfirm!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;
    $_alertMixin_saveSuccess!: () => void;
    private busy: boolean = false;
    private getGroups!: string[];
    private allowSubmit = false;


    @Watch('wipTicket', { immediate: true, deep: true})
    onPropertyChanged(value:WipTicket, oldvalue: WipTicket){
        let newWipTicketStringified = JSON.stringify(value);
        this.ticketChanged = this.originalWipTicketStringified !== newWipTicketStringified;
        this.allowSubmit = !!(value.productionOrderNum &&
            value.plant.code &&
            value.plant.code.length > 0 &&
           // value.productionOrderQty &&
            value.materialDesc &&
            value.materialNum &&
            value.onHoldBy &&
            value.salesOrderNum &&
            value.lineItem &&
            value.color &&
            value.optionNumber &&
            value.stackNumOnHold &&
            value.stacksOnHold &&
            value.shiftProduced &&
            value.qtyOnHold &&
            value.discrepancy &&
            (Discrepancy.isMissing(value.discrepancy) ? value.missingPartQty && value.missingPartNumber : true) &&
            value.workCenter &&
            value.prodDate &&
            value.comments);
    }

    constructor(){
        super()
    }

    created() {
        this.getTicket();
    }

    getTicket(){
        this.$store.dispatch(LoadingActions.LOADING, true);
        this.ticketId = parseInt(this.$route.params['wipTicketId']);
        TicketService.getWipTicketById(this.ticketId).then((response)=>{
            this.wipTicket = new WipTicket();
            this.wipTicket.initFromObject(response.data);
            this.wipTicket.loaded = true;
            this.originalWipTicketStringified = JSON.stringify(this.wipTicket);
            if (this.wipTicket.status.desc === 'Closed') {
                if (this.getGroups.includes('admin')){
                    this.headerMessage = "Admin Editing Closed WIP Ticket #"+this.wipTicket.wipTicketId
                } else {
                    this.wipTicket.disableEditAll = true;
                    this.headerMessage = "Closed WIP Ticket #"+this.wipTicket.wipTicketId
                }
            } else {
                this.headerMessage = "Editing WIP Ticket #"+this.wipTicket.wipTicketId
            }
            this.$store.dispatch(LoadingActions.LOADING, false);
        }).catch((error)=>{

        });
    }

    onSubmit() {
        let self = this;
        this.$_alertMixin_swalConfirm('Save Ticket', null, null).then((value) => {
            if (value) {
                self.busy = true;
                let wipTicketJSON = JSON.stringify(self.wipTicket.toJSON());
                TicketService.updateWipTicket(wipTicketJSON).then((response) => {
                    if (response.data === 'success') {
                        self.$_alertMixin_saveSuccess();
                        // @ts-ignore
                        this.$router.push({name: 'wip-tickets', params: {updatedTicket: this.wipTicket, updatedTicketType:'updated'}})
                    } else {
                        alert("ticket not saved! Unable to save the current ticket")
                    }
                    self.busy = false;
                }).catch((error) => {
                    alert(error);
                });
            }
        })
    }

    onReset() {
        this.wipTicket.loaded = false;
        this.$nextTick(()=>{
            this.getTicket();
        })
    }

    editAll() {
        this.wipTicket.disableEditMaterial = !this.wipTicket.disableEditMaterial;
    }
}

